import React, { useState } from 'react'
import { Box, Typography, Select, MenuItem } from '@mui/material'
import { CampaignStatus } from '../../types/campaign'
import { ExpandMore } from '@mui/icons-material'
import theme from '../theme'

interface Props {
  status: CampaignStatus
  onStatusChange: (status: string) => void
  isUpdating?: boolean
}

const StatusChip = ({ status, onStatusChange, isUpdating }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const getStatusColor = (status: CampaignStatus) => {
    switch (status) {
      case CampaignStatus.Draft:
        return theme.palette['sage-200']
      // case CampaignStatus.Booked:
      //   return theme.palette['accent-200']
      // case CampaignStatus.Reserved:
      //   return theme.palette['green-600']
      case CampaignStatus.Scheduled:
        return theme.palette['orange-500']
      case CampaignStatus.Deleted:
        return theme.palette['red-200']
      case CampaignStatus.Live:
        return theme.palette['green-500']
      case CampaignStatus.Dark:
        return theme.palette['sage-900']
      case CampaignStatus.Completed:
        return theme.palette['sage-100']
      default:
        return theme.palette['sage-200']
    }
  }

  const enableUpdate =
    status === CampaignStatus.Draft ||
    status === CampaignStatus.Scheduled ||
    status === CampaignStatus.Deleted

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4px 8px',
          borderRadius: '16px',
          backgroundColor: getStatusColor(status),
          width: 'fit-content',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography
          variant="body-2"
          sx={{
            color:
              status === CampaignStatus.Dark
                ? theme.palette['base-white']
                : theme.palette['sage-900'],
            textTransform: 'uppercase',
            lineHeight: '16px',
            fontWeight: '600',
            padding: '0 8px'
          }}
        >
          {status}
        </Typography>
        {enableUpdate && !isUpdating && (
          <ExpandMore
            sx={{
              width: '16px',
              height: '16px',
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              cursor: 'pointer'
            }}
            onClick={(e) => {
              e.stopPropagation()
              setIsExpanded(!isExpanded)
            }}
          />
        )}
        {isExpanded && (
          <Select
            onChange={(e) => {
              e.stopPropagation?.()
              onStatusChange(e.target.value as CampaignStatus)
            }}
            sx={{
              width: '0',
              height: '0',
              opacity: 0,
              position: 'absolute',
              top: '100%',
              left: '50%'
            }}
            open={isExpanded}
            onClose={() => {
              setIsExpanded(false)
            }}
          >
            {status !== CampaignStatus.Draft && (
              <MenuItem sx={{ width: '110px' }} value={CampaignStatus.Draft}>
                Draft
              </MenuItem>
            )}
            {status !== CampaignStatus.Deleted &&
              status !== CampaignStatus.Scheduled && (
                <MenuItem
                  sx={{ width: '110px' }}
                  value={CampaignStatus.Scheduled}
                >
                  Scheduled
                </MenuItem>
              )}
          </Select>
        )}
      </Box>
    </>
  )
}

export default StatusChip
